import React, { SVGProps } from 'react';

const SvgCustomGreece = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='600'
    height='400'
    viewBox='0 0 27 18'
    xmlSpace='preserve'
    className='svg-icon'
    {...props}
  >
    <rect fill='#0D5EAF' width='27' height='18' rx='8' ry='7' />
    <path fill='none' strokeWidth='2' stroke='#FFF' d='M5,0V11 M0,5H10 M10,3H27 M10,7H27 M0,11H27 M0,15H27' />
  </svg>
);

export default SvgCustomGreece;